<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="cursor-pointer rounded flex flex-col justify-center items-center border-color-grey py-[2px]"
    @click="showInfo"
  >
    <el-tooltip content="Tutorial Video" placement="top">
      <div class="flex flex-col items-center mb-2">
        <span class="text-center font-semibold text-custom-sm">Tutorial Video</span>
        <SwdButton primary small>
          <el-icon class="w-6 h-6">
            <VideoCamera style="width: 32px; height: 32px; stroke-width: 2.5" />
          </el-icon>
        </SwdButton>
      </div>
    </el-tooltip>
  </div>
  <el-dialog
    v-model="dialogVisible"
    title="Info"
    :width="getModalWidth"
    :fullscreen="getFullScreenModal"
    destroy-on-close
  >
    <el-scrollbar v-loading="isFetching" class="pr-[15px]">
      <div v-if="!isFetching && data" class="text-main">
        <div v-if="data.url" class="mb-4">
          <div class="border rounded-md p-5">
            <video controls style="width: 100%; height: 100%">
              <source :src="data.url" type="video/mp4" />
            </video>
          </div>
        </div>
        <div v-if="data.text">
          <div class="border rounded-md p-5">
            <div class="help-text-content" v-html="data.text"></div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">Close</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { VideoCamera } from '@element-plus/icons-vue'
import { computed, ref, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { useFetchClientsHelp } from '@/api/use-fetch-clients-help.js'
import { useBreakpoints } from '@/hooks/use-breakpoints'

export default {
  name: 'SwdInfoBtn',
  components: {
    VideoCamera,
  },

  setup() {
    const route = useRoute()
    const store = useStore()
    const dialogVisible = ref(false)
    const { screenType } = useBreakpoints()

    const { isLoading, data, refetch, isFetching } = useFetchClientsHelp({ enabled: false })

    watchEffect(() => {
      if (dialogVisible.value) {
        getFetchData()
      }
    })

    const getFetchData = async () => {
      if (route.name === 'lead-basic-information') {
        await store.commit('globalComponents/setPageClientsHelp', 'prospect_basic')
      }
      if (route.name === 'lead-assets-information') {
        await store.commit('globalComponents/setPageClientsHelp', 'prospect_assets_income')
      }
      if (route.name === 'lead-expense-information') {
        await store.commit('globalComponents/setPageClientsHelp', 'prospect_monthly_expenses')
      }
      if (route.name === 'relevant-financial-documents') {
        await store.commit('globalComponents/setPageClientsHelp', 'prospect_step_2')
      }
      if (route.name === 'confirmation-page') {
        await store.commit('globalComponents/setPageClientsHelp', 'prospect_confirm')
      }
      refetch.value()
    }

    const showInfo = () => {
      dialogVisible.value = true
    }

    const getModalWidth = computed(() => {
      if (screenType.value === 'lg') {
        return '70%'
      }
      if (screenType.value === 'md') {
        return '70%'
      }
      return '100%'
    })

    const getFullScreenModal = computed(() => {
      if (screenType.value === 'xs') {
        return true
      }
      return false
    })

    return {
      showInfo,
      dialogVisible,
      route,
      isLoading,
      data,
      refetch,
      isFetching,
      getModalWidth,
      getFullScreenModal,
    }
  },
}
</script>
<style scoped>
.text-custom-sm {
  font-size: 0.575rem !important;
  line-height: 1.25rem !important;
  font-style: bold !important;
}
</style>
